<template>
  <div>
    <v-layout row class="ml-4 mt-4">
      <div :class="ui.textHeadline"> besea </div>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card>
          <v-img
          class="white--text"
          height="200px"
          :src="require('@/app/assets/images/nature03.jpg')"
          >
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span class="headline"> Logged Out </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
         <v-layout row>
         <v-spacer/>
           <div :class="ui.textImage"> Nature Image </div>
         </v-layout>
         <v-card-title primary-title>
           <div :class="ui.textTitleError">
             <div class="ml-3">
               Idle Time Reached
             </div>
            </div>
           <div :class="ui.textDescription">
             <div class="ml-3 mt-2">
               An inactivity for extended period of time was noted on your account and the protection system logged you out to prevent unauthorised access. We apologise if this caused any business inconvenience, and we thank you for your cooperation.
             </div>
           </div>
        </v-card-title>
        <v-layout row>
          <v-btn flat :color="ui.btnColor" :to="'/'">
            <v-icon left> home </v-icon>
            home
           </v-btn>
          <v-spacer/>
          <v-btn flat :color="ui.btnColor" :to="'/signin'">
            <v-icon left> account_circle </v-icon>
            sign in
           </v-btn>
         </v-layout>
         <v-layout row class="mt-4">
           <PublicFooterCard :data="{bkgd: 'white'}"/>
         </v-layout>
       </v-card>
      </v-flex>
    </v-layout>
    </v-container>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";

export default {
  components: {
    PublicFooterCard
  },
  mixins: [apptheme],
  data: () => ({})
};
</script>
